module.exports = __webpack_public_path__ + "media/src/assets/cross-7ddc85894ddbe8b0aabf707315343b9a.svg";